function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2BA691",
  d: "M-105 18v9H65v-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2A8F9D",
  d: "M65 18v9h136v-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#285D99",
  d: "M-71 0v9H36V0zm-21 9v9H28V9zm293 9v9h172v-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B4697",
  d: "M36 0v9h50V0zm-8 9v9h159V9zm345 9v9h73v-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2E3195",
  d: "M86 0v9h100V0zm101 9v9h31V9zm257 9v9h43v-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#512D93",
  d: "M186 0v9h36V0zm31 9v9h69V9zm270 9v9h165v-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C2E92",
  d: "M222 0v9h94V0zm63 9v9h169V9zm367 9v9h15v-9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7A3390",
  d: "M314 0v9h61V0zm140 9v9h133V9zm213 9v9h196v-9zm-681 9v9H98v-9z"
}));

function SvgDividerLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 863 36"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4NjMgMzYiPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZmlsbD0iIzJCQTY5MSIgZD0iTS0xMDUgMTh2OUg2NXYtOXoiLz48cGF0aCBmaWxsPSIjMkE4RjlEIiBkPSJNNjUgMTh2OWgxMzZ2LTl6Ii8+PHBhdGggZmlsbD0iIzI4NUQ5OSIgZD0iTS03MSAwdjlIMzZWMHpNLTkyIDl2OUgyOFY5ek0yMDEgMTh2OWgxNzJ2LTl6Ii8+PHBhdGggZmlsbD0iIzJCNDY5NyIgZD0iTTM2IDB2OWg1MFYwek0yOCA5djloMTU5Vjl6TTM3MyAxOHY5aDczdi05eiIvPjxwYXRoIGZpbGw9IiMyRTMxOTUiIGQ9Ik04NiAwdjloMTAwVjB6TTE4NyA5djloMzFWOXpNNDQ0IDE4djloNDN2LTl6Ii8+PHBhdGggZmlsbD0iIzUxMkQ5MyIgZD0iTTE4NiAwdjloMzZWMHpNMjE3IDl2OWg2OVY5ek00ODcgMTh2OWgxNjV2LTl6Ii8+PHBhdGggZmlsbD0iIzZDMkU5MiIgZD0iTTIyMiAwdjloOTRWMHpNMjg1IDl2OWgxNjlWOXpNNjUyIDE4djloMTV2LTl6Ii8+PHBhdGggZmlsbD0iIzdBMzM5MCIgZD0iTTMxNCAwdjloNjFWMHpNNDU0IDl2OWgxMzNWOXpNNjY3IDE4djloMTk2di05ek0tMTQgMjd2OUg5OHYtOXoiLz48L2c+PC9zdmc+";
export { SvgDividerLeft as ReactComponent };